import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Percents from './Percents';
import If from './If';

const RenderDialog = (props) => (
  <Modal
    aria-labelledby="rendering-title"
    isOpen={props.isRendering}
  >
    <ModalHeader id="rendering-title">Rendering ...</ModalHeader>
    <ModalBody>
      <If condition={props.isVideoEncoderLoading}>
        Initializing ...
      </If>
      <If condition={!props.isVideoEncoderLoading}>
        <div>
          Encoding {props.canvasForRender && props.canvasForRender.height}p
        </div>
      </If>
      <If condition={props.videoEncoder && props.animationForRender}>
        {() => <div>
          <Percents
            onGetValue={props.handleGetEncoderProgress}
          />
        </div>}
      </If>
    </ModalBody>
    <ModalFooter>
      <Button
        color="secondary"
        onClick={props.handleRenderAbort}
      >
        Abort
      </Button>
    </ModalFooter>
  </Modal>
);

export default RenderDialog;



// WEBPACK FOOTER //
// ./src/components/RenderDialog.js